import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { tripOriginState } from '../../utils/tripBackTarget';

/**
 * Link into a trip timeline that records the page it was clicked on, so the
 * timeline's back link returns there instead of always to the trips list.
 */
const TripLink = ({ state, ...props }) => {
  const location = useLocation();
  return <Link {...props} state={{ ...tripOriginState(location), ...state }} />;
};

export default TripLink;
